import { tokens } from "@/shared/design-system/tokens";
import styled from "@emotion/styled";

export const AvatarUploadWrapper = styled.div`
  position: relative;
  display: inline-flex;
  cursor: pointer;

  &:focus,
  &:active,
  &:focus-visible {
    outline: none;
    -webkit-tap-highlight-color: transparent;
  }
`;

export const AvatarCircle = styled.div`
  position: relative;
  display: flex;
  width: 98px;
  height: 98px;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: ${tokens.borderRadius.full};
  padding: 6.125px;
  box-shadow:
    0 12.25px 12.25px 0 rgba(0, 0, 0, 0.25);
  overflow: hidden;
  isolation: isolate;

  /* Borde gradiente circular via pseudo-elemento + mask */
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 50%;
    padding: 6.125px;
    background: linear-gradient(
      180deg,
      ${tokens.colors.gradient.startEnd} -8.75%,
      ${tokens.colors.gradient.middle} 51.17%,
      ${tokens.colors.gradient.startEnd} 114.71%
    );
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
    z-index: 1;
  }
`;

export const AvatarImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  &:hover > img {
    filter: brightness(0.75);
  }

  &:hover > [data-overlay] {
    opacity: 1;
  }
`;

export const AvatarPreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0.75;
  transition:
    filter 0.2s ease,
    opacity 0.2s ease;
`;

export const AvatarOverlay = styled.button`
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  background: rgba(255, 255, 255, 0.60);
  backdrop-filter: blur(1px);

  opacity: 0;
  transition: opacity 0.2s ease;

  border: none;
  cursor: pointer;
  padding: 0;

  &:focus-visible {
    opacity: 1;
    outline: 2px solid ${tokens.colors.basics[100]};
    outline-offset: -2px;
  }
`;

export const PencilButton = styled.button`
  display: flex;
  width: 31px;
  height: 31px;
  padding: 6.4px;
  justify-content: center;
  align-items: center;
  gap: 6.4px;

  position: absolute;
  right: 1px;
  bottom: 1px;

  border-radius: ${tokens.borderRadius.full};
  border: 0.8px solid ${tokens.colors.basics[1500]};
  background: linear-gradient(
    180deg,
    ${tokens.colors.gradient.startEnd} -8.75%,
    ${tokens.colors.gradient.middle} 51.17%,
    ${tokens.colors.gradient.startEnd} 114.71%
  );
  box-shadow:
    0 3.2px 3.2px 0 rgba(0, 0, 0, 0.25),
    97.6px 29.6px 32.32px 0 rgba(255, 255, 255, 0.25) inset,
    148px -29.6px 12.08px 0 rgba(255, 251, 251, 0.25) inset;

  cursor: pointer;
  outline: 1px solid ${tokens.colors.basics[1500]};

  &:hover {
    background-color: transparent;
    scale: 1.1;
    box-shadow: 
    0 0 15px rgba(255, 255, 255, 0.6),
    97.6px 29.6px 32.32px 0 rgba(255, 255, 255, 0.25) inset, 
    148px -29.6px 12.08px 0 rgba(255, 251, 251, 0.25) inset;
    border-color: ${tokens.colors.basics[1500]};
    outline: 1px solid ${tokens.colors.basics[0]};
  }

  &:focus,
  &:active,
  &:focus-visible {
    background-color: transparent;
    border-color: ${tokens.colors.basics[1500]};
    outline: 1px solid ${tokens.colors.basics[1500]};
  }

`;

export const HiddenInput = styled.input`
  display: none;
`;
